export default __webpack_public_path__ + "static/media/Chat.97cf2814.svg";